module.exports = __webpack_public_path__ + "static/img/wisdomZhili7.8892b29e.png";